import NotesPage from './notes-page'

export default NotesPage
